module.exports = __webpack_public_path__ + "static/media/portal.471c3b76.svg";